import React from "react";
import PrimaryButton from "../PrimaryButton";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import ToggleButton from "../ToggleButton";
import ConfirmationModal from "../ConfirmationModal";
import ImageComponent from "../ImageComponent";
import { trimText } from "../../utils/helpers";

const CustomTable =
  ({
    data = [],
    headers = [],
    viewlink = "",
    setToggleStatus = () => { },
    handleShow = () => { },
    handleClose = () => { },
    showModal = false,
    handleConfirm = () => { },
    clickedIndex = null,
    resetlink = "",
    viewState = {},
    editlink = "",
    handleDownload = () => { },
  }) => {
    const navigate = useNavigate();
    return (
      <Table responsive bordered width="100%" cellSpacing={0}>
        <thead>
          <tr>
            {headers?.map((header, index) => (
              <th key={index}>{header?.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers?.map((header, cellIndex) => (
                <td key={cellIndex}>
                  {header?.delinkBtn ? (
                    <>
                      <PrimaryButton
                        text="Delink"
                        className="width-auto h-0 view-btn mx-2"
                        onClick={() => handleShow(rowIndex)}
                      />
                      <ConfirmationModal
                        confirmationMessage={`Are you sure you want to remove this mapping ?`}
                        confirmattionKey={rowIndex}
                        show={showModal && clickedIndex === rowIndex}
                        id={rowIndex}
                        onHide={handleClose}
                        onConfirm={() => handleConfirm(row?.id)}
                      />
                    </>
                  ) : null}
                  {header?.upperCase ? (
                    row[header?.key]?.toUpperCase()
                  ) : header?.editIcon ? (
                    <PrimaryButton
                      text="Edit"
                      className="width-auto h-0 create-btn"
                      onClick={() =>
                        navigate(`${editlink}/${row?.id ? row?.id : rowIndex}`)
                      }
                    />
                  ) : header?.trimText ? (
                    trimText(row[header?.key], 22)
                  ) :
                  header?.downloadBtn  ? (
                    <PrimaryButton
                      text="Download"
                      disabled={!row.file_id}
                      className="width-auto h-0 view-btn"
                      onClick={() => handleDownload(row[header?.key])}
                    />
                  ) 
                  : 
                  header?.resetbtn ? (
                    <PrimaryButton
                      text="Reset Password"
                      className="width-auto h-0 reset-btn"
                      onClick={() =>
                        navigate(`${resetlink}/${row?.id ? row?.id : rowIndex}`)
                      }
                    />
                  ) : header?.imagebtn ? (
                    row[header?.key] ? (
                      <ImageComponent imageId={row[header?.key]} />
                    ) : (
                      "No Image shared"
                    )
                  ) : header?.viewbtn ? (
                    <PrimaryButton
                      text="View"
                      className="width-auto view-btn "
                      onClick={() =>
                        navigate(
                          `${viewlink}/${row?.id ? row?.id : rowIndex}`,
                          {
                            state: {
                              view: true,
                              [viewState?.key1]: row[viewState?.key1],
                              [viewState?.key2]: row[viewState?.key2],
                              [viewState?.key3]: row[viewState?.key3],
                            },
                          }
                        )
                      }
                    />
                  ) : header?.togglebtn ? (
                    <>
                      <ToggleButton
                        toggle={row[header?.key]}
                        setToggle={setToggleStatus}
                        onClick={() => handleShow(rowIndex)}
                        togglekey={rowIndex}
                      />
                      <ConfirmationModal
                        confirmationMessage={`Are you sure you want to  ${row[header?.key] ? "Deactivate" : "Activate"
                          } the login credentials  ?`}
                        confirmattionKey={rowIndex}
                        show={showModal && clickedIndex === rowIndex}
                        id={rowIndex}
                        onHide={handleClose}
                        onConfirm={() => handleConfirm(row?.id)}
                      />
                    </>
                  ) : (
                    row[header?.key]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }


export default React.memo(CustomTable);
